<button type="{{type}}" class= "{{class}}" (click)="onClickbutton($event)" >{{label}}</button>
